import React from 'react';
import { TextInputExtended } from './core/text-input-extended';

interface Props {
	name: string;
	label?: string;
	value?: string;
	required?: boolean;
	infoMessage?: string;
}

const regExp = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s+]+$/;

export function LettersInput(props: Props) {
	return (
		<TextInputExtended
			{...props}
			label={props.label || 'Nombre'}
			validate={(value) => regExp.test(value)}
			errorMessage="Solo se aceptan letras"
		/>
	);
}
